function initializeCustomSlider() {
  console.log(window.screen.innerWidth)
  if(window.screen.width >= 1000) {
    const viewportHeight = window.innerHeight;
    const imageWrapper = document.querySelector('.image-list');
    const images = imageWrapper.querySelectorAll('.image-list__item');
    const diff = 117;
    const imagesLength = images.length;
    images.forEach((img) => {
      img.style.width = (window.innerHeight * 0.8);
    })
    const slideshowContainer = document.querySelector('.slideshow-container');
    slideshowContainer.style.height = `${(images.length * viewportHeight) - diff}px`
    
    function MouseWheelHandler(e) {
      const slideshowContainer = document.querySelector('.slideshow-container');
      const imageWrapper = document.querySelector('.image-list');
      const images = imageWrapper.querySelectorAll('.image-list__item');
      const imagesLength = images.length;
      console.log(imagesLength)
      const newPos = scrollY * (document.body.scrollHeight / ((window.innerHeight * 0.8) * imagesLength))
      let slideshowScroll = document.querySelector('.slideshow-scroll');
      let scrollPos = scrollY * (imageWrapper.offsetWidth / document.body.scrollHeight);
      if (scrollPos < 0) {
          scrollPos = 0;
      } else if (scrollPos > imageWrapper.offsetWidth) {
          scrollPos = imageWrapper.offsetWidth;
      }
    
      slideshowScroll.scrollLeft = scrollPos;
      e.preventDefault();
    }
  
    document.addEventListener('scroll', MouseWheelHandler);
  } else {
    const slideshowContainer = document.querySelector('.slideshow-container');
    console.log(slideshowContainer)
    slideshowContainer.style.height = 'auto'
  }
}

document.addEventListener("DOMContentLoaded", (event) => {
  initializeCustomSlider();
  window.onresize = (event) => {
    initializeCustomSlider();
  };
});

